export { default as categoriesEpic } from './epic';
export type { FetchCategoriesAction } from './actions';
export { fetchCategoriesAction } from './actions';
